// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"559":"edit-tema","842":"edit-temaer"}[chunkId] + "." + {"559":"ff5b9f77","842":"3e6a0332"}[chunkId] + ".js";
};